import React from 'react'

const Apple = ({ className }: { className?: string }) => {
    return (
        <svg className={className} fill="none" height="26" viewBox="0 0 26 26" width="26" xmlns="http://www.w3.org/2000/svg">
<path d="M17.3333 2.1665C17.7266 4.52817 15.262 6.31567 13.884 7.11842C13.4777 7.35567 13.0184 7.05342 13.0888 6.58867C13.3239 5.0265 14.1851 2.1665 17.3333 2.1665Z" stroke="currentColor" strokeWidth="1.625"></path>
<path d="M9.74998 7.0415C10.7217 7.0415 11.5808 7.25817 12.2351 7.4965C13.0799 7.79875 14.0034 7.79875 14.8481 7.4965C15.6436 7.20072 16.4847 7.04672 17.3333 7.0415C18.5087 7.0415 20.0037 7.67959 21.125 8.95575C17.3333 11.9165 18.4166 16.7915 21.9581 18.0828C20.8271 21.1888 18.6777 23.2915 16.7906 23.2915C15.1656 23.2915 15.1666 22.5332 13.5416 22.5332C11.9166 22.5332 11.9166 23.2915 10.2916 23.2915C7.58331 23.2915 4.33331 18.9582 4.33331 13.5415C4.33331 9.20817 7.58331 7.0415 9.74998 7.0415Z" stroke="currentColor" strokeWidth="1.625"></path>
</svg>
    )
}

export default Apple
